import React, { useEffect, useState } from "react";
import ListHeader from "../../../components/listing/ListHeader";
import ListFooter from "../../../components/listing/ListFooter";
import DynamicTable from "../../../components/listing/DynamicTable";
import IconEdit from "../../../components/icons/IconEdit";
import IconTrash from "../../../components/icons/IconTrash";

import FiltroContrato from "./FiltroContrato";
import EliminarContrato from "./EliminarContrato";
import GestionarContratoModal from "../../../components/Modales/GestionarContratoModal";

import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function ListaContratos() {
  // Paginación
  const [porPagina, setPorPagina] = useState(30);
  const [pagina, setPagina] = useState(1);
  const [totalBackend, setTotalBackend] = useState(0);

  // Datos
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Modales
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [contratoAEditar, setContratoAEditar] = useState(null);
  const [registroAEliminar, setRegistroAEliminar] = useState(null);

  // Filtros
  const [filtros, setFiltros] = useState({
  contratoObj: null,
  descripcionObj: null,
  data: "",
  dataFechaini: "",
  dataFechafin: "",
});

  const [reloadKey, setReloadKey] = useState(0);

  // Estado para el modal de gestión integral
  const [mostrarGestion, setMostrarGestion] = useState(false);

  // Carga de datos
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        let baseUrl = apiRoutes.contratos.listUrl({});
        if (baseUrl.includes("?")) baseUrl = baseUrl.split("?")[0];

        const queryParams = new URLSearchParams();
        queryParams.append("page", pagina - 1);
        queryParams.append("size", porPagina);
        if (filtros.contratoObj?.codigo) queryParams.append("codigo", filtros.contratoObj.codigo);
        if (filtros.descripcionObj?.descricaoTexto) queryParams.append("descricaoTexto", filtros.descripcionObj.descricaoTexto);
        if (filtros.data) queryParams.append("data", filtros.data);
        if (filtros.dataFechaini) queryParams.append("dataFechaini", filtros.dataFechaini);
        if (filtros.dataFechafin) queryParams.append("dataFechafin", filtros.dataFechafin);

        const url = `${baseUrl}?${queryParams.toString()}`;
        const res = await appFetchJson(url);

        const items = Array.isArray(res?.content) ? res.content : (Array.isArray(res?.items) ? res.items : []);
        setData(items);
        const total = res?.totalElements ?? res?.total ?? items.length;
        setTotalBackend(total);
      } catch (e) {
        console.error("Error cargando contratos:", e);
        setError("Error al cargar los datos.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [pagina, porPagina, filtros, reloadKey]);

  // Función auxiliar para formatear fecha ISO a local
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split('-');
    return `${parseInt(day, 10)}/${parseInt(month, 10)}/${year}`;
  };

  // Definición de columnas
  const columns = [
    {
      header: "Código del Contrato",
      accessor: "codigo",
      type: "text",
      width: "15%",
      cellClass: "font-medium text-gray-800",
    },
    {
      header: "Descripción del Contrato",
      accessor: "descricaoTexto",
      type: "text",
      width: "35%",
      cellClass: "whitespace-normal break-words",
    },
    {
      header: "Fecha del Contrato",
      accessor: "data",
      type: "date",
      width: "15%",
      render: (item) => formatDate(item.data),
    },
    {
      header: "Fecha Inicio",
      accessor: "dataFechaini",
      type: "date",
      width: "15%",
      render: (item) => formatDate(item.dataFechaini),
    },
    {
      header: "Fecha Final",
      accessor: "dataFechafin",
      type: "date",
      width: "15%",
      render: (item) => formatDate(item.dataFechafin),
    },
    {
      header: "Acción",
      type: "action",
      width: "10%",
      render: (item) => (
        <div className="flex justify-center items-center gap-2">
          <button
            className="p-1"
            title="Editar"
            onClick={() => {
  setContratoAEditar(item);
  setMostrarGestion(true);
}}
          >
            <IconEdit size={16} />
          </button>
          <button
            className="p-1"
            title="Eliminar"
            onClick={() => setRegistroAEliminar(item)}
          >
            <IconTrash size={16} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page">
      <ListHeader
        title="Contratos"
        filters={filtros}
        onFilterClick={() => setMostrarFiltros(true)}
        onClearFilters={() => {
  setFiltros({
    contratoObj: null,
    descripcionObj: null,
    data: "",
    dataFechaini: "",
    dataFechafin: "",
  });
  setPagina(1);
}}
        showAdd={true}
        addLabel="Gestión Integral de Contratos"
        onAddClick={() => setMostrarGestion(true)}
        pageSize={porPagina}
        onPageSizeChange={(size) => {
          setPorPagina(size);
          setPagina(1);
        }}
      />

      {loading && <div className="mt-2 text-sm text-center text-gray-600">Cargando datos...</div>}
      {error && <div className="mt-2 text-sm text-red-600">{error}</div>}

      {mostrarFiltros && (
        <FiltroContrato
          initialFilters={filtros}
          onSubmit={(nuevosFiltros) => {
  setFiltros({
    contratoObj: nuevosFiltros.contratoObj,
    descripcionObj: nuevosFiltros.descripcionObj,
    data: nuevosFiltros.data,
    dataFechaini: nuevosFiltros.dataFechaini,
    dataFechafin: nuevosFiltros.dataFechafin,
  });
  setPagina(1);
  setMostrarFiltros(false);
}}
          onClose={() => setMostrarFiltros(false)}
        />
      )}

      {!loading && <DynamicTable size="M" data={data} columns={columns} />}

      <ListFooter
        page={pagina}
        pageSize={porPagina}
        total={totalBackend}
        onPageChange={(p) => setPagina(p)}
      />

      {mostrarGestion && (
  <GestionarContratoModal
    onClose={() => {
      setMostrarGestion(false);
      setContratoAEditar(null);
    }}
    onFinish={() => {
      setReloadKey((k) => k + 1);
      setMostrarGestion(false);
      setContratoAEditar(null);
    }}
    contratoAEditar={contratoAEditar}
  />
)}

      {/* Modal Eliminar */}
      {registroAEliminar && (
        <div className="modal-backdrop" onClick={() => setRegistroAEliminar(null)}>
          <div className="modal-panel-md" onClick={(e) => e.stopPropagation()}>
            <EliminarContrato
              registro={registroAEliminar}
              onClose={() => setRegistroAEliminar(null)}
              onDeleted={() => {
                setReloadKey((k) => k + 1);
                setRegistroAEliminar(null);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}